/* common meta tag values.
It can be modified by page's metaInfo */
export default {
  title:
    '海外航空券・飛行機チケットを検索 | 海外旅行・海外ツアーなら「旅工房」',
  titleTemplate: null,
  htmlAttrs: {
    lang: 'ja',
  },
  meta: [
    { charset: 'utf-8' },
    { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
    {
      vmid: 'description',
      name: 'description',
      content:
        '海外航空券を検索。最安値の格安海外航空券の検索・予約がスピーディーに可能、オンラインで決済完了。海外格安航空券の予約なら「旅工房」。',
    },
    {
      vmid: 'keywords',
      name: 'keywords',
      content:
        '航空券,海外格安航空券,海外旅行,海外ツアー,格安ツアー,旅行会社,旅工房',
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
    { name: 'robots', content: 'index, follow' },

    {
      property: 'og:title',
      content:
        '海外航空券・飛行機チケットを検索 | 海外旅行・海外ツアーなら「旅工房」',
    },
    { property: 'og:site_name', content: '海外旅行・海外ツアー ｜ 旅工房' },
    { property: 'og:type', content: 'company' },
    { property: 'og:url', content: 'https://www.tabikobo.com/japan/hotel' },
    {
      property: 'og:image',
      content: 'https://www.tabikobo.com/images/fb_ogp.png',
    },
    {
      property: 'og:description',
      content:
        '海外航空券を検索。最安値の格安海外航空券の検索・予約がスピーディーに可能、オンラインで決済完了。海外格安航空券の予約なら「旅工房」。',
    },
  ],
}
